import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  paymentMethodOption: {
    height: 48,
    borderWidth: 1,
    borderRadius: theme.borderRadius.xs,
    paddingHorizontal: theme.spacing[4],
    justifyContent: 'center',
    variants: {
      selected: {
        true: {
          borderColor: 'transparent',
          backgroundColor: colors.backgroundPrimaryInverse,
        },
        false: {
          borderColor: colors.borderPrimary,
        },
      },
    },
  },
  paymentMethodIcon: {
    width: 38,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.backgroundL1Alpha,
    borderRadius: theme.borderRadius.xxs,

    variants: {
      selected: {
        true: {
          backgroundColor: colors.backgroundL0,
        },
        false: {
          backgroundColor: colors.backgroundPrimaryInverse,
        },
      },
    },
  },
  paymentMethodRow: {
    alignItems: 'center',
  },
  payInPersonIcon: {
    width: 38,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.backgroundPrimary,
    borderRadius: theme.borderRadius.xs,
  },
  section: {
    width: '100%',
  },
}));
